import axios from 'axios';

const options = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

export const listSponsoredVideos = async () => (await axios.get('/api/sponsored-videos', options())).data;
export const getSponsoredVideo = async (id) => (await axios.get(`/api/sponsored-videos/${id}`, options())).data;
export const createSponsoredVideo = async (input) => (await axios.post('/api/sponsored-videos', input, options())).data;
export const updateSponsoredVideo = async (id, input) => (await axios.put(`/api/sponsored-videos/${id}`, input, options())).data;
export const archiveSponsoredVideo = async (id) => (await axios.post(`/api/sponsored-videos/${id}/archive`, {}, options())).data;
export const publishSponsoredVideo = async (id, publish) => (
  await axios.post(`/api/sponsored-videos/${id}/${publish ? 'publish' : 'unpublish'}`, {}, options())
).data;
export const setSponsoredVideoGlobal = async (id, enabled) => (
  await axios.patch(`/api/sponsored-videos/${id}/global`, { enabled }, options())
).data;
export const reorderSponsoredVideos = async (videoIds) => (
  await axios.put('/api/sponsored-videos/global-order', { videoIds }, options())
).data;
export const replaceSponsoredPromotions = async (id, promotions) => (
  await axios.put(`/api/sponsored-videos/${id}/promotions`, { promotions }, options())
).data;

export const listSponsoredMedia = async () => (
  await axios.get('/api/sponsored-videos/media', options())
).data.items;

export const uploadSponsoredMedia = async (file, onProgress = () => {}) => {
  const metadata = { filename: file.name, contentType: file.type, size: file.size };
  const presigned = (await axios.post('/api/sponsored-videos/media/presign', metadata, options())).data;
  await axios.put(presigned.uploadUrl, file, {
    headers: { 'Content-Type': file.type },
    onUploadProgress: (event) => {
      if (event.total) onProgress(Math.round((event.loaded / event.total) * 100));
    },
  });
  return (await axios.post(
    '/api/sponsored-videos/media/finalize',
    { ...metadata, key: presigned.key },
    options()
  )).data;
};

export const deleteSponsoredMedia = async (key) => (
  await axios.delete('/api/sponsored-videos/media', { ...options(), data: { key } })
).data;

export const importSponsoredYoutubeVideo = async ({ videoId, title }) => (
  await axios.post('/api/sponsored-videos/media/import-youtube', { videoId, title }, options())
).data;
